/**
 * Gating for the /dev/viewer-launch playground page.
 *
 * Enabled in:
 * - Local development (NODE_ENV=development), regardless of hostname.
 * - Deployed dev and stage form-viewer hosts.
 *
 * Disabled everywhere else (including prod US, prod EU, and unknown hosts).
 *
 * Hostnames live here (rather than as env vars) because the viewer-ui ships a
 * single bundle and the host is the same signal as FORMVIEWER_URL on the
 * client. Add a new entry to PLAYGROUND_HOSTS to allow another non-prod host.
 */

const PLAYGROUND_HOSTS: ReadonlySet<string> = new Set<string>([
  'application-portal.entratadev.com',
  'application-portal.entratastage.com',
]);

export function isViewerLaunchPlaygroundEnabled(): boolean {
  if (process.env.NODE_ENV === 'development') {
    return true;
  }
  if (typeof window === 'undefined') {
    return false;
  }
  return PLAYGROUND_HOSTS.has(window.location.hostname);
}
